import { ApiStory } from "data/api/ApiStory";
import useFirebaseSession from "hooks/useFirebaseSession";
import { trackEvent } from "services/frontend/Segment";

export enum ArticleSharingMethod {
  link = "link",
  facebook = "facebook",
  twitter = "twitter",
  whatsapp = "whatsapp",
  email = "email",
  linkedin = "linkedin",
}

export function useRecordArticleShared() {
  const { user } = useFirebaseSession();

  return (story: ApiStory, shareVia: ArticleSharingMethod) => {
    let category = "";
    for (const cat of story?.categories) {
      const isFirstCategory = category === "";
      category = `${isFirstCategory ? "" : " , "}${cat?.name ?? ""}`;
    }

    trackEvent("Article Shared", {
      url: global?.window?.location?.href ?? "",
      author: story?.author?.fullName ?? "",
      category,
      article_title: story?.title ?? "",
      article_id: story?.id ?? "",
      share_via: shareVia,
      link_copied: shareVia === ArticleSharingMethod.link,
      referrer_email: user?.email ?? "",
    });
  };
}
